module.exports = __webpack_public_path__ + "static/img/logo2.39df80c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo2.png
// module id = 197
// module chunks = 1